module.exports = __webpack_public_path__ + "static/media/rear-wheels.b162ba04.svg";